const TAG_SEPARATOR = '+'
const DOT = '.'
// Gmail ignores dots, so i.an@gmail.com reaches ian@gmail.com.
const DOT_BLIND_DOMAINS = ['gmail.com', 'googlemail.com']
// Our own team signs up with +tags to test the trial.
const OWN_DOMAIN = 'counselpro.ai'

// Matches the rule lukita applies on trial signup (EmailAddress#alias? unless #ours?).
export const isEmailAlias = (address: string) => {
  const normalized = address.trim().toLowerCase()
  const atIndex = normalized.lastIndexOf('@')
  const mailbox = normalized.slice(0, atIndex)
  const domain = normalized.slice(atIndex + 1)
  if (domain === OWN_DOMAIN) return false
  return (
    mailbox.includes(TAG_SEPARATOR) ||
    (DOT_BLIND_DOMAINS.includes(domain) && mailbox.includes(DOT))
  )
}
